export default class Option {
  title = ''
  value = ''
  isConfirm = false
  borderDirection = '' // borderTop/borderBottom
  borderStyle = '1px solid gray'
  showClipboardCopyTitle = false
  isManual = false

  constructor (
    title = 'No name',
    value,
    borderDirection,
    isConfirm = false,
    showClipboardCopyTitle = false,
    isManual
  ) {
    if (!value) throw new Error(`Option "type" field is required in the ${title}`)
    this.title = title
    this.value = value
    this.borderDirection = borderDirection
    this.isConfirm = isConfirm
    this.showClipboardCopyTitle = showClipboardCopyTitle
    this.isManual = isManual
  }
}
